import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./subscriptions.module.scss";
import IconView from "@/shared/components/IconView/IconView";
import EgwWebFont from "src/assets/EgwWebFont";
import {
  CONTENT_CLASSES,
  TREE_LABEL_HIDE_IN_TREE
} from "@/shared/utils/content/content.constants";

const SubsReadViewElement = ({ item, bookType }) => {
  const makeHeaderComponent = (Comp, { id, parent, content, element_subtype }) => {
    let Tag = Comp;
    let bookTitle = "";

    if (Comp === "h1") {
      Tag = "h2";
      bookTitle = "book-title";
    }

    return (
      <div
        className={classNames(
          styles[CONTENT_CLASSES.PARAGRAPH],
          styles[element_subtype],
          styles["has-reader-view-element-indent-top"],
        )}
        data-chapter={parent ? parent.id : null}
        data-id={id}>
        <Tag
          className={classNames(bookType, styles[bookTitle])}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    );
  };

  const makeParagraph = (para) => {
    const { id, parent, content, element_subtype, refcode_short: refcodeShort } = para;
    const trans = para.translations;
    let bibleRefCode;
    if (para.treeLabel && para.treeLabel !== TREE_LABEL_HIDE_IN_TREE) {
      bibleRefCode = <span className={styles["bible-number"]}>{para.treeLabel}</span>;
    }

    return (
      <React.Fragment>
        <div className={styles["has-reader-view-element-indent-top"]} />
        {bibleRefCode}
        <span
          data-chapter={parent ? parent.id : null}
          className={classNames(styles[CONTENT_CLASSES.PARAGRAPH], styles[element_subtype])}
          data-id={id}>
          <span dangerouslySetInnerHTML={{ __html: content }} />
          {trans && trans.length > 0 && (
            <IconView
              icon={EgwWebFont.translation}
              className={styles["reader-translate-icon"]}
              data-translations={id}
            />
          )}
        </span>
        {refcodeShort && <span className={styles[CONTENT_CLASSES.REF_CODE]}>{refcodeShort}</span>}
      </React.Fragment>
    );
  };

  let itemType = item.element_type;
  if (itemType.indexOf("h") === 0 || itemType === "table") {
    return makeHeaderComponent(itemType, item);
  }
  return makeParagraph(item);
};

SubsReadViewElement.propTypes = {
  content: PropTypes.array,
  bookType: PropTypes.string,
};

export default SubsReadViewElement;
